import { Injectable } from '@angular/core';
import { IntegrationCredentials } from '../interfaces/integrationCredentials';
import { AuthService } from './authentication.service';
import { IntegrationEnum } from '../enums/integration.enum';

@Injectable({ providedIn: 'root' })
export class CompanyBillingIntegrationService {

  constructor(private readonly authService: AuthService) {
  }

  private findActiveBillingCredentials(): IntegrationCredentials[] | null {
    const company = this.authService.getCompany();
    const credentials = company && company.integrationCredentials;
    if (!credentials || !credentials.length) {
      return null;
    }
    const billingCredentials = credentials.filter((credential: IntegrationCredentials) =>
      credential && credential.state === true &&
      (credential.integrationType != null ? credential.integrationType : '').trim().toLowerCase() === 'billing'
    );
    return billingCredentials != null ? billingCredentials : null;
  }

  isSiigoBilling(): boolean {
    const credentials = this.findActiveBillingCredentials();
    if (!credentials || !credentials.length) return false;
    return credentials.some(credential => credential.integrationChannel && credential.integrationChannel.trim().toLowerCase() === IntegrationEnum.SIIGO.toLowerCase());
  }

  isBusinessCentralBilling(): boolean {
    const credentials = this.findActiveBillingCredentials();
    if (!credentials || !credentials.length) return false;
    return credentials.some(credential => credential.integrationChannel && credential.integrationChannel.trim().toLowerCase() === IntegrationEnum.BUSINESS_CENTRAL.toLowerCase());
  }
}
